import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import useManageES from 'hooks/API/useManageES';
import useES from 'hooks/API/GET/useES';
import useToaster from 'hooks/useToaster';
import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import ManageES from './ManageES';

/**
 * ManageESPage
 * Standardized page for adding or updating a Syllabus (ES).
 */
function ManageESPage() {
  const { esID } = useParams();
  const history = useHistory();
  const editMode = !!esID && esID !== 'add';

  const { isLoading: esUpdating, mutate, isError: esError } = useManageES();

  // Fetch existing ES data if in edit mode
  const { data: esData, isLoading: esFetching } = useES({
    enabled: editMode,
    configs: { params: { id: esID } },
  });

  useToaster(esUpdating, { type: esError ? 'error' : 'success' });

  const handleGoBack = () => {
    history.goBack();
  };

  const handleSave = (formData) => {
    if (esUpdating) return;

    mutate(formData, {
      onSuccess: () => {
        setTimeout(() => {
          history.push('/manage/es');
        }, 1000);
      },
    });
  };

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={handleGoBack}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Curriculum', to: '/curriculum' },
                { label: 'Syllabuses', to: '/manage/es' },
              ]}
              current={editMode ? 'Update Syllabus' : 'Add Syllabus'}
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-5">
              {esFetching ? (
                <div className="text-center p-5">Loading syllabus data...</div>
              ) : (
                <ManageES
                  save={handleSave}
                  selectedItem={esData?.data?.result?.[0] || {}}
                  handleSelectedItem={() => {}}
                  isPageMode={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageESPage;
